import { connect } from 'react-redux';
//
import { IStoreState } from 'store';
import ProductItems from 'components/deal-results/product-items/product-items';

export enum EView {
  ITEMIZED = 'itemized',
  LINE = 'line',
  SURVIVAL = 'survival',
  BOX_PLOT = 'boxPlot',
}

export enum EDisplay {
  BASE = 'base',
  SALES = 'sales',
  NETBACK = 'netback',
  MARGIN = 'margin',
}

export const EDisplayLabel = {
  [EDisplay.BASE]: 'Base Price',
  [EDisplay.SALES]: 'Revenue',
  [EDisplay.NETBACK]: 'Netback',
  [EDisplay.MARGIN]: 'Margin',
};

export enum EDateRange {
  CONTRACT_PERIOD = 'contractPeriod',
  ALL = 'all',
}

const mapStateToProps = ({ dealEdit, dealEvaluation, fieldOptions }: IStoreState) => ({
  dealEdit,
  dealEvaluation,
  fieldOptions,
});

export default connect(mapStateToProps)(ProductItems);
